import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";
import Device from "../../../../../init/device";

export default function view() {
  const $this = this;
  const { $charge } = this;

  return (view = ViewFactory({
    NAME: 'OPAY_INIT_VIEW',
    constants: { hasBackAction: false },
    next() { 
      // const visitSource = Device.deviceType;
      const visitDevice = Device.isMobile;

      let meta = getValueAtPath($this.DATA, 'meta');
      const meta_visit_source = {
        metaname: "customer_visit_source",
        metavalue: "BROWSER"
      }
      const meta_evoke_opay = {
        metaname: "evoke_opay",
        metavalue: visitDevice || false
      }
      meta.push(meta_evoke_opay, meta_visit_source);
      $charge.init({
        data: { meta }
      }) 
    }
  }).call(this));
}
